/* eslint-disable */

window.addEventListener('load', () => {
    const load_more_btn = document.querySelector('.btn--load-more');
    let page_to_load = 2;

    function load_more_posts(btn_load_more, output_container, max_pages, load_more_url, page_to_load) {
        btn_load_more.classList.add('loading');
        fetch(load_more_url + `&page=${ page_to_load }`)
            .then(response => response.json())
            .then(json => {
                json.posts.forEach(post => {

                    renderTemplate(post, output_container);

                });
                // If there is no more posts, remove load more button
                if ( page_to_load == max_pages ) {
                    btn_load_more.remove();
                }

                // Remove animation from load more btn
                btn_load_more.classList.remove("loading");
            })
            .catch(error => {
                console.error('Load more:', error);
                btn_load_more.classList.remove("loading");
            });
    }

    if ( load_more_btn ) {
        const max_pages = load_more_btn.dataset.max_pages,
            post_type = load_more_btn.dataset.post_type,
            post_type_id = load_more_btn.dataset.post_type_id,
            tax_id = load_more_btn.dataset.tax_id,
            load_more_url = `/wp-json/custom/cpt_posts?post_type=${ post_type ? post_type : '' }&post_type_id=${ post_type_id ? post_type_id : '' }&tax_id=${ tax_id ? tax_id : '' }`,
            output_container = document.querySelector('.box__posts');

        load_more_btn.addEventListener('click', () => {
            load_more_posts(load_more_btn, output_container, max_pages, load_more_url, page_to_load++);
        });
    }
});

function renderTemplate(data, output_container) {
    const { image, category_link, category_name, link, title, date, has_video } = data;
    const categoryLayout = category_link && category_name ? `<a href="${ category_link }" class="post__category">${ category_name }</a>` : '';

    let html = `<div class="post post__box post__box--bordered">
                    <div class="wrapper">
                        <a href="${ link }" class="post__image">
                        ${ has_video }
                            <picture>
                                <img src="${ image }" alt="">
                            </picture>
                        </a>
                        <div class="post__content">
                            <h3 class="post__title">
                                <a href="${ link }">${ title }</a>
                            </h3>
                            ${ categoryLayout }
                            <p class="post__date">${ date }</p>
                        </div>
                    </div>
                </div>`;

    // Insert new elements at the end of the row
    output_container.lastElementChild.insertAdjacentHTML('beforebegin', html);
}



// WEBPACK FOOTER //
// ./scripts/modules/load-more-cpt-posts.js